import { render, staticRenderFns } from "./SelectRegistrantDialog.vue?vue&type=template&id=e946e0f4&scoped=true"
import script from "./SelectRegistrantDialog.vue?vue&type=script&lang=js"
export * from "./SelectRegistrantDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectRegistrantDialog.vue?vue&type=style&index=0&id=e946e0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e946e0f4",
  null
  
)

export default component.exports